import React from 'react'
import { Modal, Form, Col, Row, Button } from 'react-bootstrap'
import { createModal, ModalResolveType, useModalAction } from '@src/lib/modal-manager'
import { useForm } from '@src/lib/react-hook-form'
import z from 'zod'
import _ from 'lodash'
import { GetPIOItemArgsRespBo } from '@src/domain/services/report.services'


interface EditPioItemArgsProps {
  itemDto: GetPIOItemArgsRespBo;
}

export function EditPioItemArgsModalWrapper(props: EditPioItemArgsProps) {
  const { resolve, remove, hide } = useModalAction()
  const { assemblyPioArgs } = props.itemDto
  const uuidList = _(assemblyPioArgs).keyBy('uuid').keys().value()
  const validateField = _.zipObject(uuidList, _.map(uuidList, () => z.string().nonempty({ message: '請輸入' })))
  const ValidateDto = _.zipObject(uuidList, _.map(uuidList, uuid => {
    const argDto = _.find(assemblyPioArgs, { uuid })
    return argDto?.value || ''
  }))
  const { register, handleSubmit, formState: { errors } } = useForm<{[field: string]: string}>({
    reValidateMode: 'onSubmit',
    defaultValues: ValidateDto,
    rules: z.object(validateField)
  })

  const handleClose = () => {
    resolve(ModalResolveType.CLOSED)
    hide()
    remove()
  }

  const handleCancel = () => {
    resolve(ModalResolveType.CANCEL)
    hide()
    remove()
  }

  const handleOnSubmit = (formDto: {[field: string]: string}) => {
    const pioArgs = _.map(assemblyPioArgs, argDto => {
      return { ...argDto, value: formDto[argDto.uuid] }
    })
    const newItemDto = { ...props.itemDto, assemblyPioArgs: pioArgs }
    resolve(ModalResolveType.OK, newItemDto)
    hide()
    remove()
  }

  return (
    <Modal size='lg' show onHide={handleClose} centered>
      <Form onSubmit={handleSubmit(handleOnSubmit)}>
        <Modal.Header closeButton>
          <Modal.Title>編輯PIO項目參數</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {
            _.map(uuidList, uuid => {
              const argDto = _.find(assemblyPioArgs, { uuid })
              return <Form.Group as={Row} className="mb-3">
                <Form.Label column sm="2">
                  {argDto?.fieldName}
                </Form.Label>
                <Col sm="10">
                  <Form.Control {...register(uuid)} />
                </Col>
                {errors[uuid] && <Form.Text className='text-danger'>{errors[uuid].message}</Form.Text>}
              </Form.Group>
            })
          }
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleCancel} variant='light'>
            取消
          </Button>
          <Button type='submit'>
            確認
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export const EditPioItemArgsModal = createModal(EditPioItemArgsModalWrapper)
